
/**
 * Custom component for CHI three column menu section.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.2.0
 * @copyright  Copyright (C) 2023-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2023-09-25 (1.0.0) (jhoward)
 *      - <chi-three-column-section> adds a three-column layout for CHI menu sections.
 *
 *    2025-03-18 (1.1.0) (jhoward)
 *      - Add support for textual menus in the <chi-three-section-column> component.
 *
 *    2025-04-08 (1.2.0) (jhoward)
 *      - Replace "menuVersion" prop with "menu" prop in <chi-three-section-column>.
 */

import {defineComponent, PropType} from "vue";
import {Menu, MenuSection} from "../defs";
import ChiDefaultSection from "./Chi_defaultSection.vue";

export default defineComponent({
  name: 'Bimini_threeColumnSection',
  components: {ChiDefaultSection},
  props: {
    menu: {
      type: Object as PropType<Menu>,
      required: true
    },
    section: {
      type: Object as PropType<MenuSection>,
      required: true
    },
  },
})
